import { HBO_SUBSCRIPTION_MARKER } from '../constants';

// El servicio /services/user/v1/superhighlight devuelve un arreglo de flags de la cuenta;
// solo el valor EXACTO 'suscripto_hbo' indica suscripcion activa. 'no_suscripto_hbo' (u
// otros valores) NUNCA debe interpretarse como suscripcion activa, aunque este en el mismo
// arreglo.
export const isHboSubscriptionActive = superhighlight =>
  Array.isArray(superhighlight) && superhighlight.includes(HBO_SUBSCRIPTION_MARKER);
